import { dayOf, describe } from '../../dates';
import { useLanguage } from '../../contexts/language';

import { Initials } from '../initials';

import styles from './style.module.css';

// One clinician the patient is connected with, in Settings: initials, name
// and since when. What they share with each clinician joins here when
// sharing is built (O06).
export function ClinicianCard({ clinician }) {
  const { text, language } = useLanguage();
  const { firstName, lastName, connectedSince } = clinician;

  return (
    <article className={ styles.card }>
      <Initials firstName={ firstName } lastName={ lastName }/>

      <span className={ styles.lines }>
        <span className={ styles.name }>{ `${ firstName } ${ lastName }` }</span>
        <span className={ styles.detail }>{ text.connectedSince.replace('{date}', describe({ day: dayOf(connectedSince), language, short: true })) }</span>
      </span>
    </article>
  );
}
